import React, { Component, Fragment } from "react";
import { Carousel, Container, Image } from "react-bootstrap";
import { withTranslation } from "react-i18next";
import { connect } from "react-redux";
import dollar from "../../assets/images/icon-dollar.svg";
import Contact from "../../components/UI/Alerts/Contact/Contact";
import Button from "../../components/UI/Button/Button";
import Modal from "../../components/UI/Modal/Modal";
import { logFirebaseEvent } from "../../shared/utility";
import * as actions from "../../store/actions/index.js";
import classes from "./BalanceBilling.module.css";
import OverviewOfBills from "./Claims/Claims";

interface IStateFromProps {
  config_values: {
    customValue: string | null;
    defaultValue: string;
    element: string;
    elementType: string;
    id: string;
    targetPageTitle: string;
  }[];
  balanceBillView: string;
  t: any;
}
interface IDispatchFromProps {
  onResetSearchParam: () => void;
  onRemoveExplanationOfBenefitsFiles: (fileArray: File[]) => void;
  onRemoveProviderBillsFiles: (fileArray: File[]) => void;
  onRemovePatientsResponsibilityFiles: (fileArray: File[]) => void;
  onResetDisputeAuthorizationFile: () => void;
  onResetFetchAllClaims: () => void;
  onSetBalanceBillViewState: (balanceBillView) => void;
  onShouldUploadDocument: (shouldUpload: boolean) => void;
}

type Props = IStateFromProps & IDispatchFromProps;
class BalanceBilling extends Component<Props> {
  state = {
    connect: false,
    getStarted: false,
    getStartedAgain: false,
  };
  
  componentDidMount() {
    logFirebaseEvent("BalanceBillMain");
    this.props.onResetDisputeAuthorizationFile();
    this.props.onResetSearchParam();
    this.props.onRemoveProviderBillsFiles([]);
    this.props.onRemovePatientsResponsibilityFiles([]);
    this.props.onRemoveExplanationOfBenefitsFiles([]);
    this.props.onResetFetchAllClaims();
    this.props.onShouldUploadDocument(false);
  }
  componentDidUpdate(prevProps, prevState) {
    //   console.log("prevProps.balanceBillView", prevProps.balanceBillView);
    //   console.log("this.props.balanceBillView", this.props.balanceBillView);
    //   console.log("this.state.getstarted", this.state.getStarted);
    //   console.log("this.state.getstartedAgain", this.state.getStartedAgain);
    if (prevProps.balanceBillView !== this.props.balanceBillView) {
      console.log(
        "inside prevProps.balanceBillView",
        prevProps.balanceBillView
      );
      console.log(
        "inside this.props.balanceBillView",
        this.props.balanceBillView
      );
      if (this.props.balanceBillView === "getStarted") {
        this.setState({ getStarted: true });
        this.setState({ getStartedAgain: false });
        logFirebaseEvent("ClaimsList");
      } else if (this.props.balanceBillView === "notGetStarted") {
        this.setState({ getStarted: false });
        this.setState({ getStartedAgain: false });
      } else if (this.props.balanceBillView === "") {
        this.setState({ getStartedAgain: true });
        this.setState({ getStarted: false });
        logFirebaseEvent("ClaimsList");
      }
    }
  }

  getStartedHandler = () => {
    
    this.props.onSetBalanceBillViewState("getStarted");
    // this.setState({ getStarted: true });
  };
  goBackHandler = () => {
    this.props.onSetBalanceBillViewState("notGetStarted");
    // this.setState({ getStarted: false });
  };
  contactAdvocacyHandler = () => {
    logFirebaseEvent("ContactAdvocacyButtonPressed");
    this.setState({ connect: true });
    
  };
  connectedHandler = () => {
    this.setState({ connect: false });
  };
  render() {
    console.log("this.state.getstarted in render", this.state.getStarted);
    console.log(
      "this.state.getstartedAgain in render",
      this.state.getStartedAgain
    );
    console.log("this.state.getstarted", this.state.getStarted);
    const { t } = this.props;
    const btnStyle = { padding: "7px 12px" };
    const modalContact = {
      width: "360px",
      left: "calc(50% - 180px)",
    };
    let overviewOfBills: any;
    if (this.state.getStarted || this.state.getStartedAgain) {
      overviewOfBills = <OverviewOfBills goBackHandler={this.goBackHandler} />;
    } else {
      overviewOfBills = (
        <Fragment>
          <Modal
            show={this.state.connect}
            childComp={
              <Contact
                modalClosed={this.connectedHandler}
                email={t("contact.info")}
                contactNumber="(800) 425-9373"
                contactText={t("contact.contactAdvocacy")}
                logEvent="ContactAdvocacyEmailButtonPressed"
              />
            }
            style={modalContact}
          ></Modal>
          <Container fluid>
            <Carousel
              controls={false}
              interval={null}
              indicators={true}
              className={classes.carousel}
            >
              <Carousel.Item>
                <div className="carouselBanner carouselBannerImg">
                  <h2 className="carouselTitle">
                    {t("balanceBills.scrollBarTitle1")}
                  </h2>
                  <Image src={dollar} alt="dollar" />
                </div>
                <div className={classes.bannerContent}>
                  <p>
                    {this.props.config_values &&
                    this.props.config_values.find(
                      (ele) =>
                        ele.targetPageTitle.toLowerCase() ===
                          "What is Balance Bill ?".toLowerCase() &&
                        ele.element.toLowerCase() ===
                          "Description".toLowerCase()
                    )
                      ? this.props.config_values.find(
                          (ele) =>
                            ele.targetPageTitle.toLowerCase() ===
                              "What is Balance Bill ?".toLowerCase() &&
                            ele.element.toLowerCase() ===
                              "Description".toLowerCase()
                        )?.customValue
                        ? this.props.config_values
                            .find(
                              (ele) =>
                                ele.targetPageTitle.toLowerCase() ===
                                  "What is Balance Bill ?".toLowerCase() &&
                                ele.element.toLowerCase() ===
                                  "Description".toLowerCase()
                            )
                            ?.customValue?.split("\n")
                            .map((item, key) => {
                              return (
                                <span key={key}>
                                  {item}
                                  <br />
                                </span>
                              );
                            })
                        : this.props.config_values
                            .find(
                              (ele) =>
                                ele.targetPageTitle.toLowerCase() ===
                                  "What is Balance Bill ?".toLowerCase() &&
                                ele.element.toLowerCase() ===
                                  "Description".toLowerCase()
                            )
                            ?.defaultValue?.split("\n")
                            .map((item, key) => {
                              return (
                                <span key={key}>
                                  {item}
                                  <br />
                                </span>
                              );
                            })
                      : `${t("balanceBilling.description")}
                      ${localStorage.getItem("clientName")} ${t(
                          "balanceBilling.secondDescription"
                        )}`}
                  </p>
                  {/* <p>
                    {this.props.config_values &&
                    this.props.config_values.find(
                      (ele) =>
                        ele.targetPageTitle.toLowerCase() ===
                          "What is Balance Bill ?".toLowerCase() &&
                        ele.element.toLowerCase() ===
                          "Description".toLowerCase()
                    )
                      ? this.props.config_values.find(
                          (ele) =>
                            ele.targetPageTitle.toLowerCase() ===
                              "What is Balance Bill ?".toLowerCase() &&
                            ele.element.toLowerCase() ===
                              "Description".toLowerCase()
                        )?.customValue
                        ? this.props.config_values
                            .find(
                              (ele) =>
                                ele.targetPageTitle.toLowerCase() ===
                                  "What is Balance Bill ?".toLowerCase() &&
                                ele.element.toLowerCase() ===
                                  "Description".toLowerCase()
                            )
                            ?.customValue?.split("\n\n")[1]
                          ? this.props.config_values
                              .find(
                                (ele) =>
                                  ele.targetPageTitle.toLowerCase() ===
                                    "What is Balance Bill ?".toLowerCase() &&
                                  ele.element.toLowerCase() ===
                                    "Description".toLowerCase()
                              )
                              ?.customValue?.split("\n\n")[1]
                          : ""
                        : this.props.config_values
                            .find(
                              (ele) =>
                                ele.targetPageTitle.toLowerCase() ===
                                  "What is Balance Bill ?".toLowerCase() &&
                                ele.element.toLowerCase() ===
                                  "Description".toLowerCase()
                            )
                            ?.defaultValue.split("\n\n")[1]
                      : `Get started below by uploading your individual bills.`}
                  </p> */}
                </div>
              </Carousel.Item>
              <Carousel.Item>
                <div className="carouselBanner">
                  {/* {t('balanceBills.scrollBarTitle2')} */}
                  <h2 className="carouselTitle">
                    {t("balanceBills.scrollBarTitle2")}
                  </h2>
                </div>
                <div className={classes.bannerContent}>
                  {/* <div className={classes.listItems}>
                    <p>
                      <strong>
                        {this.props.config_values &&
                        this.props.config_values.find(
                          (ele) =>
                            ele.targetPageTitle.toLowerCase() ===
                              "How do I determine my Balance Bill ?".toLowerCase() &&
                            ele.element.toLowerCase() ===
                              "Description".toLowerCase()
                        )
                          ? this.props.config_values.find(
                              (ele) =>
                                ele.targetPageTitle.toLowerCase() ===
                                  "How do I determine my Balance Bill ?".toLowerCase() &&
                                ele.element.toLowerCase() ===
                                  "Description".toLowerCase()
                            )?.customValue
                            ? this.props.config_values
                                .find(
                                  (ele) =>
                                    ele.targetPageTitle.toLowerCase() ===
                                      "How do I determine my Balance Bill ?".toLowerCase() &&
                                    ele.element.toLowerCase() ===
                                      "Description".toLowerCase()
                                )
                                ?.customValue?.split("\n\n")[0]
                                .split("\n")[0]
                            : this.props.config_values
                                .find(
                                  (ele) =>
                                    ele.targetPageTitle.toLowerCase() ===
                                      "How do I determine my Balance Bill ?".toLowerCase() &&
                                    ele.element.toLowerCase() ===
                                      "Description".toLowerCase()
                                )
                                ?.defaultValue.split("\n\n")[0]
                                .split("\n")[0]
                          : `What We Need to Get Started:`}
                      </strong>
                    </p>
                    <ul>
                      <li>
                        {this.props.config_values &&
                        this.props.config_values.find(
                          (ele) =>
                            ele.targetPageTitle.toLowerCase() ===
                              "How do I determine my Balance Bill ?".toLowerCase() &&
                            ele.element.toLowerCase() ===
                              "Description".toLowerCase()
                        )
                          ? this.props.config_values.find(
                              (ele) =>
                                ele.targetPageTitle.toLowerCase() ===
                                  "How do I determine my Balance Bill ?".toLowerCase() &&
                                ele.element.toLowerCase() ===
                                  "Description".toLowerCase()
                            )?.customValue
                            ? this.props.config_values
                                .find(
                                  (ele) =>
                                    ele.targetPageTitle.toLowerCase() ===
                                      "How do I determine my Balance Bill ?".toLowerCase() &&
                                    ele.element.toLowerCase() ===
                                      "Description".toLowerCase()
                                )
                                ?.customValue?.split("\n\n")[0]
                                .split("\n")[1]
                            : this.props.config_values
                                .find(
                                  (ele) =>
                                    ele.targetPageTitle.toLowerCase() ===
                                      "How do I determine my Balance Bill ?".toLowerCase() &&
                                    ele.element.toLowerCase() ===
                                      "Description".toLowerCase()
                                )
                                ?.defaultValue.split("\n\n")[0]
                                .split("\n")[1]
                          : `Copy of Explanation of Benefits`}
                      </li>
                      <li>
                        {this.props.config_values &&
                        this.props.config_values.find(
                          (ele) =>
                            ele.targetPageTitle.toLowerCase() ===
                              "How do I determine my Balance Bill ?".toLowerCase() &&
                            ele.element.toLowerCase() ===
                              "Description".toLowerCase()
                        )
                          ? this.props.config_values.find(
                              (ele) =>
                                ele.targetPageTitle.toLowerCase() ===
                                  "How do I determine my Balance Bill ?".toLowerCase() &&
                                ele.element.toLowerCase() ===
                                  "Description".toLowerCase()
                            )?.customValue
                            ? this.props.config_values
                                .find(
                                  (ele) =>
                                    ele.targetPageTitle.toLowerCase() ===
                                      "How do I determine my Balance Bill ?".toLowerCase() &&
                                    ele.element.toLowerCase() ===
                                      "Description".toLowerCase()
                                )
                                ?.customValue?.split("\n\n")[0]
                                .split("\n")[2]
                            : this.props.config_values
                                .find(
                                  (ele) =>
                                    ele.targetPageTitle.toLowerCase() ===
                                      "How do I determine my Balance Bill ?".toLowerCase() &&
                                    ele.element.toLowerCase() ===
                                      "Description".toLowerCase()
                                )
                                ?.defaultValue.split("\n\n")[0]
                                .split("\n")[2]
                          : `Copy of Itemized Bill/Statement`}
                      </li>
                    </ul>

                    <p>
                      <strong>
                        {this.props.config_values &&
                        this.props.config_values.find(
                          (ele) =>
                            ele.targetPageTitle.toLowerCase() ===
                              "How do I determine my Balance Bill ?".toLowerCase() &&
                            ele.element.toLowerCase() ===
                              "Description".toLowerCase()
                        )
                          ? this.props.config_values.find(
                              (ele) =>
                                ele.targetPageTitle.toLowerCase() ===
                                  "How do I determine my Balance Bill ?".toLowerCase() &&
                                ele.element.toLowerCase() ===
                                  "Description".toLowerCase()
                            )?.customValue
                            ? this.props.config_values
                                .find(
                                  (ele) =>
                                    ele.targetPageTitle.toLowerCase() ===
                                      "How do I determine my Balance Bill ?".toLowerCase() &&
                                    ele.element.toLowerCase() ===
                                      "Description".toLowerCase()
                                )
                                ?.customValue?.split("\n\n")[1]
                                .split("\n")[0]
                            : this.props.config_values
                                .find(
                                  (ele) =>
                                    ele.targetPageTitle.toLowerCase() ===
                                      "How do I determine my Balance Bill ?".toLowerCase() &&
                                    ele.element.toLowerCase() ===
                                      "Description".toLowerCase()
                                )
                                ?.defaultValue.split("\n\n")[1]
                                .split("\n")[0]
                          : `What We Need to File a Dispute:`}
                      </strong>
                    </p>
                    <ul>
                      <li>
                        {this.props.config_values &&
                        this.props.config_values.find(
                          (ele) =>
                            ele.targetPageTitle.toLowerCase() ===
                              "How do I determine my Balance Bill ?".toLowerCase() &&
                            ele.element.toLowerCase() ===
                              "Description".toLowerCase()
                        )
                          ? this.props.config_values.find(
                              (ele) =>
                                ele.targetPageTitle.toLowerCase() ===
                                  "How do I determine my Balance Bill ?".toLowerCase() &&
                                ele.element.toLowerCase() ===
                                  "Description".toLowerCase()
                            )?.customValue
                            ? this.props.config_values
                                .find(
                                  (ele) =>
                                    ele.targetPageTitle.toLowerCase() ===
                                      "How do I determine my Balance Bill ?".toLowerCase() &&
                                    ele.element.toLowerCase() ===
                                      "Description".toLowerCase()
                                )
                                ?.customValue?.split("\n\n")[1]
                                .split("\n")[1]
                            : this.props.config_values
                                .find(
                                  (ele) =>
                                    ele.targetPageTitle.toLowerCase() ===
                                      "How do I determine my Balance Bill ?".toLowerCase() &&
                                    ele.element.toLowerCase() ===
                                      "Description".toLowerCase()
                                )
                                ?.defaultValue.split("\n\n")[1]
                                .split("\n")[1]
                          : `Proof of Paid Patient Responsibility`}{" "}
                      </li>
                      <li>
                        {this.props.config_values &&
                        this.props.config_values.find(
                          (ele) =>
                            ele.targetPageTitle.toLowerCase() ===
                              "How do I determine my Balance Bill ?".toLowerCase() &&
                            ele.element.toLowerCase() ===
                              "Description".toLowerCase()
                        )
                          ? this.props.config_values.find(
                              (ele) =>
                                ele.targetPageTitle.toLowerCase() ===
                                  "How do I determine my Balance Bill ?".toLowerCase() &&
                                ele.element.toLowerCase() ===
                                  "Description".toLowerCase()
                            )?.customValue
                            ? this.props.config_values
                                .find(
                                  (ele) =>
                                    ele.targetPageTitle.toLowerCase() ===
                                      "How do I determine my Balance Bill ?".toLowerCase() &&
                                    ele.element.toLowerCase() ===
                                      "Description".toLowerCase()
                                )
                                ?.customValue?.split("\n\n")[1]
                                .split("\n")[2]
                            : this.props.config_values
                                .find(
                                  (ele) =>
                                    ele.targetPageTitle.toLowerCase() ===
                                      "How do I determine my Balance Bill ?".toLowerCase() &&
                                    ele.element.toLowerCase() ===
                                      "Description".toLowerCase()
                                )
                                ?.defaultValue.split("\n\n")[1]
                                .split("\n")[2]
                          : `Signed Balance Bill Kit`}
                      </li>
                    </ul>
                  </div> */}
                  <p>
                    {this.props.config_values &&
                    this.props.config_values.find(
                      (ele) =>
                        ele.targetPageTitle.toLowerCase() ===
                          "How do I determine my Balance Bill ?".toLowerCase() &&
                        ele.element.toLowerCase() ===
                          "Description".toLowerCase()
                    )
                      ? this.props.config_values.find(
                          (ele) =>
                            ele.targetPageTitle.toLowerCase() ===
                              "How do I determine my Balance Bill ?".toLowerCase() &&
                            ele.element.toLowerCase() ===
                              "Description".toLowerCase()
                        )?.customValue
                        ? this.props.config_values
                            .find(
                              (ele) =>
                                ele.targetPageTitle.toLowerCase() ===
                                  "How do I determine my Balance Bill ?".toLowerCase() &&
                                ele.element.toLowerCase() ===
                                  "Description".toLowerCase()
                            )
                            ?.customValue?.split("\n")
                            .map((item, key) => {
                              return (
                                <span key={key}>
                                  {item}
                                  <br />
                                </span>
                              );
                            })
                        : this.props.config_values
                            .find(
                              (ele) =>
                                ele.targetPageTitle.toLowerCase() ===
                                  "How do I determine my Balance Bill ?".toLowerCase() &&
                                ele.element.toLowerCase() ===
                                  "Description".toLowerCase()
                            )
                            ?.defaultValue?.split("\n")
                            .map((item, key) => {
                              return (
                                <span key={key}>
                                  {item}
                                  <br />
                                </span>
                              );
                            })
                      : ``}
                  </p>
                </div>
              </Carousel.Item>
              <Carousel.Item>
                <div className="carouselBanner">
                  <h2 className="carouselTitle">
                    {t("balanceBills.scrollBarTitle3")}
                  </h2>
                </div>
                <div className={classes.bannerContent}>
                  <p>
                    {/*{this.props.config_values &&
                    this.props.config_values.find(
                      (ele) =>
                        ele.targetPageTitle.toLowerCase() ===
                          "What happens next ?".toLowerCase() &&
                        ele.element.toLowerCase() ===
                          "Description".toLowerCase()
                    )
                      ? this.props.config_values.find(
                          (ele) =>
                            ele.targetPageTitle.toLowerCase() ===
                              "What happens next ?".toLowerCase() &&
                            ele.element.toLowerCase() ===
                              "Description".toLowerCase()
                        )?.customValue
                        ? this.props.config_values
                            .find(
                              (ele) =>
                                ele.targetPageTitle.toLowerCase() ===
                                  "What happens next ?".toLowerCase() &&
                                ele.element.toLowerCase() ===
                                  "Description".toLowerCase()
                            )
                            ?.customValue?.split("\n\n")[0]
                        : this.props.config_values
                            .find(
                              (ele) =>
                                ele.targetPageTitle.toLowerCase() ===
                                  "What happens next ?".toLowerCase() &&
                                ele.element.toLowerCase() ===
                                  "Description".toLowerCase()
                            )
                            ?.defaultValue.split("\n\n")[0]
                      :t('balanceBills.forthDescription')}
                  </p>
                  <p>
                    <i>
                      {this.props.config_values &&
                      this.props.config_values.find(
                        (ele) =>
                          ele.targetPageTitle.toLowerCase() ===
                            "What happens next ?".toLowerCase() &&
                          ele.element.toLowerCase() ===
                            "Description".toLowerCase()
                      )
                        ? this.props.config_values.find(
                            (ele) =>
                              ele.targetPageTitle.toLowerCase() ===
                                "What happens next ?".toLowerCase() &&
                              ele.element.toLowerCase() ===
                                "Description".toLowerCase()
                          )?.customValue
                          ? this.props.config_values
                              .find(
                                (ele) =>
                                  ele.targetPageTitle.toLowerCase() ===
                                    "What happens next ?".toLowerCase() &&
                                  ele.element.toLowerCase() ===
                                    "Description".toLowerCase()
                              )
                              ?.customValue?.split("\n\n")[1]
                          : this.props.config_values
                              .find(
                                (ele) =>
                                  ele.targetPageTitle.toLowerCase() ===
                                    "What happens next ?".toLowerCase() &&
                                  ele.element.toLowerCase() ===
                                    "Description".toLowerCase()
                              )
                              ?.defaultValue.split("\n\n")[1]
                        : `Need help with a Balance Bill? Get started uploading your
                      balance bill below or contact our Advocacy Team at (800)
                      425-9373.`}
                              </i>*/}
                    {this.props.config_values &&
                    this.props.config_values.find(
                      (ele) =>
                        ele.targetPageTitle.toLowerCase() ===
                          "What happens next ?".toLowerCase() &&
                        ele.element.toLowerCase() ===
                          "Description".toLowerCase()
                    )
                      ? this.props.config_values.find(
                          (ele) =>
                            ele.targetPageTitle.toLowerCase() ===
                              "What happens next ?".toLowerCase() &&
                            ele.element.toLowerCase() ===
                              "Description".toLowerCase()
                        )?.customValue
                        ? this.props.config_values
                            .find(
                              (ele) =>
                                ele.targetPageTitle.toLowerCase() ===
                                  "What happens next ?".toLowerCase() &&
                                ele.element.toLowerCase() ===
                                  "Description".toLowerCase()
                            )
                            ?.customValue?.split("\n")
                            .map((item, key) => {
                              return (
                                <span key={key}>
                                  {item}
                                  <br />
                                </span>
                              );
                            })
                        : this.props.config_values
                            .find(
                              (ele) =>
                                ele.targetPageTitle.toLowerCase() ===
                                  "What happens next ?".toLowerCase() &&
                                ele.element.toLowerCase() ===
                                  "Description".toLowerCase()
                            )
                            ?.defaultValue?.split("\n")
                            .map((item, key) => {
                              return (
                                <span key={key}>
                                  {item}
                                  <br />
                                </span>
                              );
                            })
                      : ``}
                  </p>
                </div>
              </Carousel.Item>
            </Carousel>
            <div className={classes.equalButons}>
              <Button
                label={t("balanceBills.getStartedBtn")}
                clicked={this.getStartedHandler}
                style={btnStyle}
                displayImg={false}
                image=""
                disabled={false}
              />
              <Button
                label={t("balanceBills.contactAdvocacyBtn")}
                clicked={this.contactAdvocacyHandler}
                style={btnStyle}
                displayImg={false}
                image=""
                disabled={false}
              />
            </div>
          </Container>
        </Fragment>
      );
    }
    return <Fragment>{overviewOfBills}</Fragment>;
  }
}
const mapStateToProps = (state: any) => ({
  config_values: state.appConfig.config_values,
  balanceBillView: state.setBalanceBillViewState.balanceBillView,
});
const mapDispatchToProps = (dispatch): IDispatchFromProps => ({
  onResetSearchParam: () => dispatch(actions.resetSearchParam()),
  onRemoveExplanationOfBenefitsFiles: (explanationOfBenefitsBills) =>
    dispatch(actions.explanationOfBenefitsBills(explanationOfBenefitsBills)),
  onRemoveProviderBillsFiles: (providerBills) =>
    dispatch(actions.providerBills(providerBills)),
  onRemovePatientsResponsibilityFiles: (patientsResponsibilityBills) =>
    dispatch(actions.patientsResponsibilityBills(patientsResponsibilityBills)),
  onResetDisputeAuthorizationFile: () =>
    dispatch(actions.resetDisputeAuthorizationFile()),
  onResetFetchAllClaims: () => dispatch(actions.resetFetchAllClaims()),
  onSetBalanceBillViewState: (balanceBillView) =>
    dispatch(actions.setBalanceBillViewState(balanceBillView)),
  onShouldUploadDocument: (shouldUplaod) =>
    dispatch(actions.shouldUploadDocument(shouldUplaod)),
});
// export default connect(mapStateToProps, mapDispatchToProps)(BalanceBilling);
// export default BalanceBilling;
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withTranslation()(BalanceBilling));
